import {CalendarDateFormatter, DateFormatterParams} from 'angular-calendar';
import {getISOWeek} from 'date-fns';
import {DatePipe} from '@angular/common';

export class CustomDateFormatter extends CalendarDateFormatter {
  public weekViewTitle({ date, locale }: DateFormatterParams): string {
    const year: string = new DatePipe('pl-PL').transform(date, 'y', 'pl-PL');
    const weekNumber: number = getISOWeek(date);
    return `Semaine ${weekNumber} pl ${year}`;
  }

  public dayViewHour({date, locale}: DateFormatterParams): string {
    console.log({date, locale}, new Intl.DateTimeFormat('pl-PL', {hour: 'numeric'}).format(date));
    return new Intl.DateTimeFormat('pl-PL', {hour: 'numeric'}).format(date);
  }
}



// WEBPACK FOOTER //
// ./src/utils/custom-date-formatter.ts